export function formatBytes(bytes: number | null | undefined, decimals = 1): string {
  if (bytes == null || Number.isNaN(bytes)) return '—'
  if (bytes === 0) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']
  const i = Math.min(Math.floor(Math.log(Math.abs(bytes)) / Math.log(k)), sizes.length - 1)
  return `${(bytes / Math.pow(k, i)).toFixed(decimals)} ${sizes[i]}`
}

export function formatBytesPerSec(bytesPerSec: number | null | undefined): string {
  if (bytesPerSec == null) return '—'
  return `${formatBytes(bytesPerSec)}/s`
}

export function formatUptime(seconds: number | null | undefined): string {
  if (seconds == null) return '—'
  const days = Math.floor(seconds / 86400)
  const hours = Math.floor((seconds % 86400) / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  if (days > 0) return `${days}d ${hours}h`
  if (hours > 0) return `${hours}h ${minutes}m`
  return `${minutes}m`
}

export function formatPercent(v: number | null | undefined, decimals = 1): string {
  if (v == null) return '—'
  return `${v.toFixed(decimals)}%`
}

/** Derives per-second rate widgets from two consecutive cumulative-counter
 *  series points (network/disk-IO counters are cumulative since boot). */
export function deriveRateSeries(
  series: { time: string; [k: string]: any }[],
  field: string,
): { time: string; value: number }[] {
  const out: { time: string; value: number }[] = []
  for (let i = 1; i < series.length; i++) {
    const prev = series[i - 1][field]
    const curr = series[i][field]
    if (typeof prev !== 'number' || typeof curr !== 'number') continue
    const dtSeconds = (new Date(series[i].time).getTime() - new Date(series[i - 1].time).getTime()) / 1000
    if (dtSeconds <= 0) continue
    const delta = curr - prev
    out.push({ time: series[i].time, value: delta >= 0 ? delta / dtSeconds : 0 })
  }
  return out
}
